<template>
    <div id="gate" class="info_modal" v-if="gate_active">
        <div class="gate_inner">
            <div id="gate_header">
                <h2 id="gate_title">Before You Begin...</h2>
            </div>
            <div class="gate_inner_pad">
                <div id="gate_body" class="row" v-if="!form_success">
                    <div class="span_12">
                        <p>
                            Thank you for your interest in the Take A Stand For Healthy Relationships Curriculum! We hope you find our materials useful in your discussions with teens regarding healthy relationships and teen dating violence. Because this is a sensitive topic, we recommend that you take a few minutes to read the following critical resources. These are designed to help you so that you are as prepared as possible to provide safe assistance, support, and help students, whether they are experiencing abuse, witnessing abuse at home, or wanting to help a friend or family member.
                        </p>
                        <ul class="gate_list">
                            <li><a target="_blank" href="https://ncadv.org/assets/2497/what_is_teen_dating_violence.pdf?1509129008032">What is Teen Dating Violence?</a></li>
                            <li><a target="_blank" href="https://ncadv.org/assets/2497/facts_about_teen_dating_violence.pdf?1509137216441">Facts About Teen Dating Violence</a></li>
                            <li><a target="_blank" href="https://ncadv.org/assets/2497/warning_signs_of_teen_dating_violence.pdf?1509130312431">Warning Signs of Teen Dating Violence</a></li>
                            <li><a target="_blank" href="https://ncadv.org/assets/2497/resources_for_teens_where_to_get_help.pdf?1509129026138">Resources for Teens: Where to Get Help</a></li>
                            <li><a target="_blank" href="https://ncadv.org/assets/2497/how_to_help_when_a_student_is_being_abused.pdf?1509129774156">How to Help: When a Student is Being Abused</a></li>
                            <li><a target="_blank" href="https://ncadv.org/assets/2497/mandatory_reporting.pdf?1509129983833">Mandatory Reporting</a></li>
                        </ul>
                        <p>If you know of a teen in immediate need of help, contact the teen dating violence hotline at: 1-866-331-9474</p>
                    </div>
                </div>
                <div id="gate_form" v-if="!form_success">
                    <div class="row">
                        <div class="span_6_xs">
                            <div class="gate_input_container">
                                <label class="gate_input_label" :class="{active: focused == 'first'}" for="first_name">First Name</label>
                                <input class="gate_input"
                                    :class="{ invalid: errors.has('first_name') }"
                                    v-validate="'required'"
                                    v-model="form.first_name"
                                    @focusout="focused = ''"
                                    @focus="set_focus('first')"
                                    type="text"
                                    name="first_name"
                                    placeholder="First Name">
                                <span v-show="errors.has('first_name')" class="error_message paragraph">{{ errors.first('first_name') }}</span>
                            </div>
                        </div>
                        <div class="span_6_xs">
                            <div class="gate_input_container">
                                <label class="gate_input_label" :class="{active: focused == 'last'}" for="last_name">Last Name</label>
                                <input class="gate_input" type="text"
                                    v-validate="'required'"
                                    v-model="form.last_name"
                                    :class="{ invalid: errors.has('last_name') }"
                                    @focusout="focused = ''"
                                    @focus="set_focus('last')"
                                    name="last_name"
                                    placeholder="Last Name">
                                <span v-show="errors.has('last_name')" class="error_message paragraph">{{ errors.first('last_name') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="span_12">
                            <div class="gate_input_container">
                                <label class="gate_input_label" :class="{active: focused == 'email'}" for="email">Email</label>
                                <input class="gate_input"
                                    :class="{ invalid: errors.has('email') }"
                                    @focusout="focused = ''"
                                    @focus="set_focus('email')"
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    v-model="form.email"
                                    v-validate="'required|email'">
                                <span v-show="errors.has('email')" class="error_message paragraph">{{ errors.first('email') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="gate_form_radio row">
                        <div class="span_12">
                            <div class="form_radio_row row no_wrap align_center">
                                <span class="gate_radio_main_label paragraph">I am an:</span>
                                <div class="gate_radio_container edu row no_wrap align_center"
                                    @click="set_radio('edu')"
                                    :class="{ active: form.custom_field_1 == 'Educator' }">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                                        <g fill="none" fill-rule="evenodd">
                                            <circle class="bullet_outer" cx="13" cy="13" r="12" stroke="#777"/>
                                            <circle class="bullet_inner" cx="13" cy="13" r="6" fill="#E4E4E4"/>
                                        </g>
                                    </svg>
                                    <span class="gate_radio_label paragraph">Educator</span>
                                </div>
                                <div class="gate_radio_container adv row no_wrap align_center"
                                    @click="set_radio('adv')"
                                    :class="{ active: form.custom_field_1 == 'Advocate' }">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                                        <g fill="none" fill-rule="evenodd">
                                            <circle class="bullet_outer" cx="13" cy="13" r="12" stroke="#777"/>
                                            <circle class="bullet_inner" cx="13" cy="13" r="6" fill="#E4E4E4"/>
                                        </g>
                                    </svg>
                                    <span class="gate_radio_label paragraph">Advocate</span>
                                </div>
								<div class="gate_radio_container other row no_wrap align_center"
                                    @click="set_radio('other')"
                                    :class="{ active: form.custom_field_1 == '' || !['Educator', 'Advocate'].includes(form.custom_field_1)}">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                                        <g fill="none" fill-rule="evenodd">
                                            <circle class="bullet_outer" cx="13" cy="13" r="12" stroke="#777"/>
                                            <circle class="bullet_inner" cx="13" cy="13" r="6" fill="#E4E4E4"/>
                                        </g>
                                    </svg>
                                    <span class="gate_radio_label paragraph">Other</span>
                                </div>
                                <div class="gate_radio_other" v-if="form.custom_field_1 == '' || !['Educator', 'Advocate'].includes(form.custom_field_1)">
                                    <input v-validate="'required'" class="gate_input other" type="text" name="other" v-model="form.custom_field_1">
                                    <span v-show="errors.has('other')" class="error_message paragraph">If choosing Other, it can't be blank.</span>
                                </div>
                            </div>
                            <div class="row no_wrap align_center">
                                <span class="gate_radio_main_label paragraph">How did you find out about us?</span>
                                <div class="gate_radio_container edu row no_wrap align_center"
                                    @click="set_radio('ncadv')"
                                    :class="{ active: form.custom_field_2 == 'NCADV' }">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                                        <g fill="none" fill-rule="evenodd">
                                            <circle class="bullet_outer" cx="13" cy="13" r="12" stroke="#777"/>
                                            <circle class="bullet_inner" cx="13" cy="13" r="6" fill="#E4E4E4"/>
                                        </g>
                                    </svg>
                                    <span class="gate_radio_label paragraph">NCADV</span>
                                </div>
                                <div class="gate_radio_container adv row no_wrap align_center"
                                    @click="set_radio('dis')"
                                    :class="{ active: form.custom_field_2 == 'Discovery Education' }">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                                        <g fill="none" fill-rule="evenodd">
                                            <circle class="bullet_outer" cx="13" cy="13" r="12" stroke="#777"/>
                                            <circle class="bullet_inner" cx="13" cy="13" r="6" fill="#E4E4E4"/>
                                        </g>
                                    </svg>
                                    <span class="gate_radio_label paragraph">Discovery Education</span>
                                </div>
								<div class="gate_radio_container other row no_wrap align_center"
                                    @click="set_radio('other_2')"
                                    :class="{ active: form.custom_field_2 == '' || !['NCADV', 'Discovery Education'].includes(form.custom_field_2)}">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                                        <g fill="none" fill-rule="evenodd">
                                            <circle class="bullet_outer" cx="13" cy="13" r="12" stroke="#777"/>
                                            <circle class="bullet_inner" cx="13" cy="13" r="6" fill="#E4E4E4"/>
                                        </g>
                                    </svg>
                                    <span class="gate_radio_label paragraph">Other</span>
                                </div>
                                <div class="gate_radio_other" v-if="form.custom_field_2 == '' || !['NCADV', 'Discovery Education'].includes(form.custom_field_2)">
                                    <input v-validate="'required'" class="gate_input other" type="text" name="other" v-model="form.custom_field_2">
                                    <span v-show="errors.has('other')" class="error_message paragraph">If choosing Other, it can't be blank.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify_center">
                        <button id="gate_submit" @click="submit_form">submit</button>
                    </div>
                    <div class="row justify_center close_gate_row">
                        <p>Already entered your email? <span class="text_link gate_text_link" @click="$emit('closegate')">Click here.</span></p>
                    </div>
                </div>
                <div id="gate_success" v-if="form_success">
                    <h3 class="gate_success_message">Thank you! Your submission was recieved.</h3>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
    import anime from 'animejs';
    import axios from 'axios';

    export default {
        data() {
            return {
                focused: '',
                form: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    custom_field_1: 'Educator',
                    custom_field_2: 'NCADV'
                },
                form_success: false
            }
        },
        props: ['gate_active'],
        methods: {
            set_focus(input) {
                this.focused = input;
            },
            set_radio(radio) {

                switch (radio) {
                    case 'edu':
                        this.form.custom_field_1 = 'Educator';
                        break;
                    case 'adv':
                        this.form.custom_field_1 = 'Advocate';
                        break;
                    case 'other':
                        this.form.custom_field_1 = '';
                        break;
                    case 'ncadv':
                        this.form.custom_field_2 = 'NCADV';
                        break;
                    case 'dis':
                        this.form.custom_field_2 = 'Discovery Education';
                        break;
                    case 'other_2':
                        this.form.custom_field_2 = '';
                        break;
                }
            },
            submit_form() {

                this.$validator.validateAll();

                if (this.errors.items.length == 0) {
                    let data = {
                        first_name: this.form.first_name,
                        last_name: this.form.last_name,
                        email: this.form.email,
                        custom_fields: [
                            {
                                name: 'custom_field_1',
                                value: this.form.custom_field_1,
                            },
                            {
                                name: 'custom_field_2',
                                value: this.form.custom_field_2
                            }
                        ]
                    }

                    axios.post(process.env.SERVER_URL, data).then((response) => {
                        this.form_success = true;
                        setTimeout(() => {
                            this.$emit('closegate');
                        }, 2000);
                        console.log(response);
                    }).catch(error => console.log(error));
                }

            }
        }
    }
</script>

<style lang="scss">
    @import '../../../assets/scss/variables';

    #gate {
        position: fixed;
    }

    .gate_inner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: white;
		width: 1400px;
		max-width: calc(100% - 24px);
		max-height: 100%;
        overflow: auto;
    }

    .gate_inner_pad {
        padding: 24px 10%;
    }

    #gate_header {
        padding: 48px 0;
        background-color: $dash_light_purple;
    }

    #gate_title {
        text-align: center;
        font-family: $playfair;
        color: #fff;
    }

    .gate_list {
        list-style-position: outside;
        margin-left: -12px;
        padding-left: 28px;
    }

    .form_radio_row {
        margin-bottom: 24px;
    }

    .gate_input_container {
        position: relative;
        margin-bottom: 12px;
    }

    .gate_input {
        width: 100%;
        outline: none;
        border: 1px solid $grey_medium;
        height: 48px;
        padding: 0 12px;
        box-sizing: border-box;

        &::placeholder {
            transition: all 500ms;
        }

        &:focus::placeholder {
            opacity: 0;
            transform: translateY(4px);
        }

        &.invalid {
            border-color: red;
        }

    }

    .gate_input_label {
        position: absolute;
        bottom: 100%;
        display: block;
        opacity: 0;
        transform: translateY(-4px);
        transition: all 500ms;
        &.active {
            opacity: 1;
            transform: none;
        }

    }

    .error_message {
        color: red;
        line-height: 1.25;
        position: absolute;
        top: 100%;
    }

    .gate_radio_container {
        cursor: pointer;
        height: 48px;

        &.active {

            .bullet_outer {
                stroke: $dash_medium_purple;
                transition: stroke 500ms;
            }

            .bullet_inner {
                fill: $dash_medium_purple;
                transition: fill 500ms;
            }
        }
    }

    .gate_radio_main_label {
        margin-right: 24px;
        margin-bottom: 0;
        white-space: nowrap;
		color: $grey_medium;
    }

    .gate_radio_label {
        margin-left: 6px;
		color: $grey_medium;
        white-space: nowrap;
    }

    .gate_radio_other {
        position: relative;
        width: 100%;

        .error_message {
            position: absolute;
            top: 100%;
        }
    }

    #gate_submit {
        border-color: $dash_medium_purple;
        background-color: $dash_medium_purple;
        color: white;
        font-family: $open_sans;
        margin: 24px 0;
        transition: background-color 300ms;

        &:hover {
            background-color: darken($dash_medium_purple, 10%);
        }
    }

    .gate_text_link {
        text-decoration: underline;
        cursor: pointer;

        &:hover {
            color: $dash_medium_purple
        }
    }

    .gate_success_message {
        text-align: center;
        color: $dash_dark_purple;
    }
</style>



// WEBPACK FOOTER //
// gate.vue?2dda8ba2